import {Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

import Checkbox from '~/react/components/Checkbox'

const AuthoriseCheckbox = ({agreed, toggle}) => {
  const {t} = useTranslation('points')

  return (
    <Checkbox
      size="lg"
      alignItems="flex-start"
      isChecked={agreed}
      onChange={toggle}
    >
      <Text fontSize="base">
        {t('points:qantasConnectionDrawer.authoriseCheckbox')}
      </Text>
    </Checkbox>
  )
}

AuthoriseCheckbox.propTypes = {
  agreed: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default AuthoriseCheckbox
